import {JacksonType} from "@sonner/jackson-service-v2";

@JacksonType("RpsFilter")
export class RpsFilter {

  documento: string;

  idMunicipio: number;

  captcha: string;

  numeroRps: string;

  documentoTomador: string;

}
